import UserMediaUploadDocument from './UserMediaUploadDocument';

export default UserMediaUploadDocument;
